<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" v-shortkey="['esc']" @shortkey="cerrar"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Solicitud de descuento {{ obj_solicitud_descuento.dte }}
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <div class="marco_datos">
                            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%;text-align: center;">
                                            Codigo
                                        </th>
                                        <th style="width: 40%;">
                                            Descripcion
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Precio
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Cantidad
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Sub Total
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in obj_solicitud_descuento.listado" :key="index">
                                        <td style="text-align: center;">
                                            {{ item.codigo }}
                                        </td>
                                        <td>
                                            {{ item.nombre }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.precio.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.cantidad }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.subtotal.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <label for="" class="form-label">Comentarios</label>
                        <b-form-textarea id="textarea" v-model="comentarios" placeholder="Escribe aquí el comentario"
                            rows="3" max-rows="6"></b-form-textarea>
                    </div>
                    <div class="col-sm-12 mt-3 mb-3">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="enviar_solicitud">Enviar solicitud</button>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'ModalVistaPrevia',
        computed: {
            ...mapState(['obj_solicitud_descuento', 'id_empresa_seleccionada', 'datos_usuario'])
        },
        data() {
            return {
                comentarios: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },

            async enviar_solicitud() {
                // this.obj_solicitud_descuento.solicitud_descuento = true

                // let b = {
                //     api: `movimientos-cabeceras/g/ventas`,
                //     formulario: this.obj_solicitud_descuento
                // }

                // let rr = await this.guardar_data(b)

                let f = {
                    api: `solicitud-descuentos/g/registro`,
                    formulario: {
                        obj_venta: this.obj_solicitud_descuento,
                        // no_documento: this.obj_solicitud_descuento.dte,
                        // listado: this.obj_solicitud_descuento.listado,
                        comentarios: this.comentarios,
                        // usuario: this.datos_usuario.id,
                        // empresa: this.id_empresa_seleccionada,
                        // sucursal: this.datos_usuario.sucursal_asignada,
                        // fecha: moment(Date.now()).format('YYYY-MM-DD')
                    }
                }

                await this.guardar_data(f)

                this.$emit('limpiar')
                this.cerrar()
            },
            ...mapActions(['guardar_data'])
        },
    }
</script>

<style>
    .marco_datos {
        width: 100%;
        height: 250px;
        border: 1px solid #eee;
        overflow: auto;
    }
</style>